import UserUpdateModal from "./UserUpdateModal"

export default UserUpdateModal
